module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"titles":{"deleteCase":"Delete case","deleteCasePlusCandidateProfile":"Delete case + Candidate\u0027s profile","deleteCasePlusEC":"Delete case + EC"},"texts":{"deleteCase":"Are you sure you want to delete case?","deleteCasePlusCandidateProfile":"Confirm to delete Candidate\u0027s profile and ALL their cases","deleteCasePlusEC":"Are you sure you want to delete case + EC"}}}')
  delete Component.options._Ctor
}
